import { Box } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { useLang } from "../../Hooks";
import { ReportsContent } from "./components/ReportsContent";
import { useServicesReports } from "./hooks/useServicesReports";

const ServicesPage = () => {
  const { texts } = useLang();
  const reportsTexts = texts.reports || {};
  const [tabIndex, setTabIndex] = useState(0);
  const { error, loading, reportsData } = useServicesReports(texts);

  useEffect(() => {
    localStorage.setItem("language", texts.en);
  }, [texts.en]);

  const activeReport = useMemo(() => {
    if (tabIndex < reportsData.financialStatements.length) {
      return reportsData.financialStatements[tabIndex];
    }

    if (
      tabIndex <
      reportsData.financialStatements.length +
        reportsData.financialRatios.length
    ) {
      const ratioIndex = tabIndex - reportsData.financialStatements.length;
      return reportsData.financialRatios[ratioIndex];
    }

    return null;
  }, [tabIndex, reportsData]);

  const getErrorMessage = () => {
    if (texts.en === "Arabic") {
      return `${error} - الرجاء المحاولة مرة أخرى`;
    }

    return `${error} - Please try again`;
  };

  const getActiveReportType = () => {
    if (tabIndex < reportsData.financialStatements.length) {
      return "financial";
    }

    if (
      tabIndex <
      reportsData.financialStatements.length +
        reportsData.financialRatios.length
    ) {
      return "ratios";
    }

    return "advanced";
  };

  return (
    <Box dir={texts.en === "ar" ? "rtl" : "ltr"}>
      <ReportsContent
        activeReport={activeReport}
        activeReportType={getActiveReportType()}
        error={error}
        getErrorMessage={getErrorMessage}
        loading={loading}
        reportsData={reportsData}
        reportsTexts={reportsTexts}
        setTabIndex={setTabIndex}
        tabIndex={tabIndex}
        texts={texts}
      />
    </Box>
  );
};

export default ServicesPage;
